import { IPromise } from 'angular';
import { ServiceLocator } from '../app/ServiceLocator';
import { Filter } from '../ts/helpers/Filter';
import { FlowDetailInfo, FlowListItemInfo } from '../ts/models/FlowInfo';
import { IContentInfo } from '../ts/models/IContentInfo';
import { Flows } from '../ts/resources/Flows';

export function getFlowDetailInfo(flowId: string): IPromise<FlowDetailInfo> {
  const resource = ServiceLocator.get<Flows>('Flows');
  return resource.getById(flowId);
}

export function getFlowListItemInfos(flows: IContentInfo[]): IPromise<FlowListItemInfo[]> {
  const flowIdArray = flows.map(flow => flow.id);
  const flowsResource = ServiceLocator.get<Flows>('Flows');
  return flowsResource.all()
    .addFilter(Filter.stringFieldInArray('id', flowIdArray))
    .getSlice(0, flows.length)
    .then(list => {
      return list.items;
    });
}

